export default {
    getSavedPage(state) {
        return state.savedPage;
    },
    getSavedContent(state) {
        return state.savedContent;
    },
}